import * as R from 'ramda';

const URL_SEPARATOR = '/';

type SplitUrls = (segment: string) => string[];
const splitUrls: SplitUrls = R.compose(R.without(''), R.split(URL_SEPARATOR));

type GetUrlParts = (segments: string[]) => string[];
const getUrlParts: GetUrlParts = R.chain(splitUrls);

type AppendSegment = (segment: string) => (segments: string[]) => string[];
const appendSegment: AppendSegment = R.append;

const isRelativeBack = R.equals('..');
const isRelativeForward = R.equals('.');

type BuildUrlForSegment = (segment: string) => (segments: string[]) => string[];
const buildUrlForSegment: BuildUrlForSegment = R.cond([
  [isRelativeBack, R.always(R.dropLast(1))],
  [isRelativeForward, R.always(R.identity)],
  [R.T, appendSegment]
]);

const mergeSegments = (segments: string[], newSegment: string): string[] =>
  buildUrlForSegment(newSegment)(segments);

type CreateUrlSegments = (urlParts: string[]) => string[];
const createUrlSegments: CreateUrlSegments = R.reduce(mergeSegments, []);

type CreateUrl = (segments: string[]) => string;
/**
 * Creates url from given url segments.
 *
 * @param {string[]} segments - url segments.
 * @return {string} url
 * */
export const createUrl: CreateUrl = R.compose(R.join(URL_SEPARATOR), createUrlSegments, getUrlParts);

export const isQueryParamTrue = (value: string): boolean => value === 'true';
